import { render, staticRenderFns } from "./sys_notice.vue?vue&type=template&id=47ad7eae&scoped=true"
import script from "./sys_notice.vue?vue&type=script&lang=js"
export * from "./sys_notice.vue?vue&type=script&lang=js"
import style0 from "./sys_notice.vue?vue&type=style&index=0&id=47ad7eae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ad7eae",
  null
  
)

export default component.exports